import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLongArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 72 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M71.06 13.06a1.5 1.5 0 0 0 0-2.12l-9.545-9.547a1.5 1.5 0 1 0-2.122 2.122L67.88 12l-8.486 8.485a1.5 1.5 0 1 0 2.122 2.122zM0 13.5h70v-3H0z" })
});
export default SvgLongArrowRight;
